<template>
    <section class="banner_games" :class="{ 'd-none': $route.name === 'Casino' }" v-if="$siteSettings?.data && ($route.name=='Home' || $route.name=='sports' || $route.matched.some(route => route.components.default.name === 'GamesModule'))">
        <section v-if="$siteSettings?.data && ($route.name=='Home' || $route.name=='sports')" class="banner-section">
            <Carousel :wrapAround="true" :breakpoints="breakpoints" :items-to-show="1" :autoplay="2500"
                class="owl-carousel owl-theme">
                <Slide v-for="(poster,index) in sitePosters" :key="index">
                    <div class="item">
                        <div class="main-slider-img owl-item">
                            <figure>
                                <img :src="$siteSettings?.data?.aws_url + $siteSettings?.data?.storage_path.poster_path + poster?.image"
                                    :alt="poster?.image" /></figure>
                        </div>
                    </div>
                </Slide>
            </Carousel>
        </section>
    </section>
    <SportSelection @loadGame="loadGame" :casinoGames="casinoGames" :allCasinoSections="allCasinoSections"/>
    <div class="container">
        <div class="row g-0">
            <div class="col-sm-12 col-md-4 col-lg-2">
                <SideMenu />
            </div>
            <div class="col-sm-12 col-md-12 col-lg-7">
                <div class="rit-side-content">
                    <div class="row">
                        <div class="col-sm-12 col-md-12 col-lg-12">
                            
                            <section class="inplay-game-sec" v-if="allData?.inplay?.length > 0">
                                <div class="main-heading thm-header-title">
                                    <div class="heading-content">
                                        <h1><i class="fa-solid fa-circle-play"></i> {{$t('inplay','In Play')}}</h1>
                                    </div>
                                    <div class="open-bet-staus" v-if="$auth.status">
                                        <a href="javascript:void(0);" @click="callOpenBet()">{{$t('open-bets','Open Bets')}} <span >{{
                                            $store.getters.stateUser.bets_count ?? 0 }}</span></a>
                                    </div>
                                </div>
                                <div class="inplay-match-list heading_line">
                                    <template v-for="(sport, sIndex) in { ...inplayMatches, ...secondaryInplayMatches }" :key="sIndex">
                                        
                                        <div class="inplay-game-box">
                                            <template v-if="sport.length > 0">
                                                <div class="inplay-item-heading home-game-bx">
                                                    <h2>
                                                        <img class="me-1" :src="getSportImage(inplayMatches[sIndex]?.[0]?.sport_id ?? secondaryInplayMatches[sIndex]?.[0]?.sport_id)" alt="inplay-game-icon">
                                                        <span>{{ sIndex == 'Soccer' ? $t('football','Football') : $t(sIndex.toLowerCase(),sIndex) }}</span>
                                                    </h2>
                                                    <div class="inplay-heading-title">
                                                        <ul>
                                                            <li>1</li>
                                                            <li>X</li>
                                                            <li>2</li>
                                                        </ul>
                                                        
                                                    </div>
                                                </div>
                                                <div v-for="(match, m_index) in sport" :key="m_index" class="inplay-item bet-slip-area"
                                                    :id="'mid:' + match?.matchId + ':runner:' + match?.runners?.[0]?.sid + 'inplay'" >
                                                    <SportItem :betDetails="betDetails" :match="match" :marketOdds="inplayMarketOdds" :eventType="'inplay'" @addBet="addBet"/>
                                                </div>
                                            </template>
                                        </div>
                                    </template>
                                </div>
                            </section>
                            
                            <section class="inplay-game-sec upcoming-events-sec unicon-provider" v-if="this.casinoGames?.menus?.find(menu => menu.slug == 'indian-card-games')?.games?.length">
                                <div class="main-heading nav-pills-arrows-sec">
                                    <div class="heading-content-home">
                                        <img src="@/assets/images/Indian-Games.svg" alt="indian-games"> <h1>{{$t('indian-card-games',' Indian Card Games')}}</h1>
                                    </div>
                                    <div class="nav-pills-arrows">
                                    <button class="see-all-btn" @click="showAll.indianCard = !showAll.indianCard">{{ showAll.indianCard ? 'See Less' : 'See All' }}</button>
                                    <button class="nav-arrows-left" type="button" @click="scrollLeft(1)"> <img loading="lazy" src="@/assets/images/arrow-left.svg" alt="arrow-left"></button>
                                    <button class="nav-arrows-right" type="button" @click="scrollRight(1)"> <img loading="lazy" src="@/assets/images/arrow-right.svg" alt="arrow-right"></button>
                                </div>
                                </div>
                                <div class="scrollCont indianCardGames" :class="[showAll.indianCard ? 'gridColumns' : 'gridRow', indianCardGamesClass]">
                                    <ul ref="slideItem1">
                                        <li class="scrollCont_games_types" v-for="(item,index) in this.casinoGames?.menus?.find(menu => menu.slug == 'indian-card-games')?.games" :key="index"
                                            @click="loadGame(item)">
                                            <img :src="item?.image || require('@/assets/images/default-casino.png')" :alt="item.game_name" loading="lazy">
                                        </li>
                                    </ul>
                                </div> 
                               
                            </section>
                            <section class="inplay-game-sec upcoming-events-sec unicon-provider" v-if="this.casinoGames?.menus?.find(menu => menu.slug == 'popular-games')?.games?.length">
                                <div class="main-heading nav-pills-arrows-sec">
                                    <div class="heading-content-home">
                                        <img src="@/assets/images/provider-icon.svg" alt="popular-games"> <h1>{{$t('popular-games',' Popular Games')}} </h1>
                                    </div>
                                    <div class="nav-pills-arrows">
                                    <button class="see-all-btn" @click="showAll.popularGames = !showAll.popularGames">{{ showAll.popularGames ? 'See Less' : 'See All' }}</button>
                                    <button class="nav-arrows-left" type="button" @click="scrollLeft(2)"> <img loading="lazy" src="@/assets/images/arrow-left.svg" alt="arrow-left"></button>
                                    <button class="nav-arrows-right" type="button" @click="scrollRight(2)"> <img loading="lazy" src="@/assets/images/arrow-right.svg" alt="arrow-right"></button>
                                </div>
                                </div>
                                
                                <div class="scrollCont indianCardGames" :class="[showAll.popularGames ? 'gridColumns' : 'gridRow', popularGameClass]">
                                    <ul ref="slideItem2">
                                        <li class="scrollCont_games_types" v-for="(item,index) in this.casinoGames?.menus?.find(menu => menu.slug == 'popular-games')?.games" :key="index"
                                            @click="loadGame(item)">
                                            <img :src="item?.image || require('@/assets/images/default-casino.png')" class="casino-img" :alt="item.game_name" loading="lazy">
                                        </li>
                                        
                                    </ul>
                                </div> 
                               
                            </section>
                            <section class="inplay-game-sec upcoming-events-sec unicon-provider" v-if="this.allCasinoSections?.find(section => section.slug == 'providers')?.games?.length">
                                <div class="main-heading nav-pills-arrows-sec">
                                    <div class="heading-content-home">
                                        <img src="@/assets/images/provider-icon.svg"> <h1>{{$t('casino-provider',' Game Providers')}}</h1>
                                    </div>
                                    <div class="nav-pills-arrows">
                                        <button class="see-all-btn" @click="showAll.gameProvider = !showAll.gameProvider"> {{ showAll.gameProvider ? 'See Less' : 'See All' }}</button>
                                        <button class="nav-arrows-left" type="button" @click="scrollLeft(0)"> <img loading="lazy" src="@/assets/images/arrow-left.svg" alt="arrow-left"></button>
                                        <button class="nav-arrows-right" type="button" @click="scrollRight(0)"> <img loading="lazy" src="@/assets/images/arrow-right.svg" alt="arrow-right"></button>
                                    </div>
                                </div>
                                <div class="scrollCont gameProviders" :class="[showAll.gameProvider ? 'gridColumns' : 'gridRow', gameProviderClass]">
                                    <ul ref="slideItem0">
                                        <li class="scrollCont_games_types" v-for="(item,index) in this.allCasinoSections?.find(section => section.slug == 'providers')?.games" :key="index"
                                            @click="routeToCasinoAsPerProvider(item?.provider_id)">
                                            <img :src="item?.image" class="casino-img"  :alt="item.game_name" loading="lazy">
                                        </li>
                                    </ul>
                                </div> 
                            </section>
                            <section class="inplay-game-sec upcoming-events-sec">
                                <div class="main-heading">
                                    <div class="heading-content">
                                        <h1><img src="@/assets/images/upcoming.svg" alt="upcoming" class="upcoming"> {{$t('upcoming-events','Upcoming Events')}}</h1>
                                    </div>
                                </div>
                                <div class="inplay-match-list">
                                    <div class="inplay-game-box" v-for="(sport, sIndex) in { ...upcomingMatches, ...secondaryUpcomingMatches }" :key="sIndex">
                                        <template v-if="sport.length > 0">
                                            <div class="inplay-item-heading home-game-bx">
                                                <h2>
                                                    <img class="me-1" :src="getSportImage(upcomingMatches[sIndex]?.[0]?.sport_id ?? secondaryUpcomingMatches[sIndex]?.[0]?.sport_id)" alt="inplay-game-icon">
                                                    <span>{{ sIndex == 'Soccer' ? $t('football','Football') : $t(sIndex.toLowerCase(),sIndex) }}</span>
                                                </h2>
                                                <div class="inplay-heading-title">
                                                    <ul>
                                                        <li>1</li>
                                                        <li>X</li>
                                                        <li>2</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div v-for="(match, m_index) in sport" :key="m_index" class="inplay-item bet-slip-area"
                                                :id="'mid:' + match?.matchId + ':runner:' + match?.runners?.[0]?.sid + 'upcoming'" >
                                                <SportItem :betDetails="betDetails" :match="match" :marketOdds="upcomingMarketOdds" :eventType="'upcoming'" @addBet="addBet"/>
                                            </div>
                                        </template>
                                    </div>
                                    <div v-if="upcomingMatches?.length==0">
                                        {{$t('no-real-records','No Real-Time Records Found')}}
                                    </div>
                                </div>
                            </section>
                            
                           
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="betSlipSection">
        <BetSlip id="bet-slip"
            :marketBookAndExposure="marketOdds"
            :betDetails="betDetails"
            @cancelBetSlip="CancelBetSlip()"
            @counterStartForCloseBet="counterStartForCloseBet()"
            :updateRunnerBook="false"
            ref="betSlip"
        />
    </div>
    <Offers />
</template>

<script>
import { Carousel, Slide, Pagination } from 'vue3-carousel';
import { defineAsyncComponent } from 'vue';
import socketService from "../socket/sport-socket-service";
import { checkForLockedMatches, checkInEventMangeForSection, checkEventManageforSports } from '@/shared/services/eventLocks.js';
import addBet from "@/modules/sports/services/addBet.js"
import { mapGetters } from 'vuex';
import loadCasinoGame from '@/shared/services/casinoGamesHandler.js';

export default {
    name: 'Home',
    extends: addBet,
    components: {
        Carousel,
        Slide,
        Pagination,
        SportItem: defineAsyncComponent(() =>
			import('@/modules/sports/components/SportItem.vue')
		),
        BetSlip: defineAsyncComponent(() =>
			import('@/modules/sports/components/BetSlip.vue')
		),
        SideMenu: defineAsyncComponent(() =>
			import('@/shared/components/header/SideMenu.vue')
		),
        SportSelection: defineAsyncComponent(() =>
			import('@/shared/components/sport-selection/SportSelection.vue')
		),
        Offers: defineAsyncComponent(() =>
            import('@/shared/components/modal/Offers.vue')
        )
    },
    data() {
        return {
            sectionsList: null,
            betCloseSetTimeOut: null,
            delayTimer: 0,
            sectionWiseGamesList: [
                {
                    slugName: 'indian-card-games',
                    gamesList: null,
                },
                {
                    slugName: 'popular-games',
                    gamesList: null,
                },
            ],
            inplayMatches: {},
            recommendedMatches: {},
            upcomingMatches: {},
            allData: {},
            betDetails: null,
            favouriteGamesList: this.$store?.getters?.favouriteGames,
			favouriteSportsList: this.$store?.getters?.favouriteGames,
			eventManage: null,
            secondaryInplayMatches:{},
            secondaryUpcomingMatches:{},
            breakpoints: {
                0: {
                    itemsToShow: 1,
                    snapAlign: 'start',
                },
                480: {
                    itemsToShow: 1,
                    snapAlign: 'start',
                },
                668: {
                    itemsToShow: 3,
                    snapAlign: 'start',
                }
            },
            inplayMarketOdds: {},
            upcomingMarketOdds: {},
            isBetSlipRendered: false,
            slideItemsRefs: [],
            showAll: {
                gameProvider: false,
                indianCard: false,
                popularGames: false,
            },
            pastDivId: null
        }
    },
    mounted() {
        this.getCasinoGamesServiceCall();
        this.getInplayMatches();
        this.getUpcomingMatches();
        this.callOfferPage()
    },
    computed: {
        ...mapGetters(['gamesData','getSportImage']),
        sitePosters() {
            if (this.$siteSettings.data && this.$siteSettings.data.poster && this.$siteSettings.data.poster.length) {                
                return this.$siteSettings.data.poster.filter(s => s.poster_type == 1);
            } else {
                return [];
            }
        },
        allCasinoSections(){
            return this.gamesData?.sections
        },
        casinoGames(){
            return this.gamesData?.sections?.find(section => section.slug == 'casino');
        },
        gameProviderClass() {
            const gameProvider = this.allCasinoSections?.find(section => section.slug == 'providers')?.games || [];
            if (gameProvider.length < 8) {
                return 'gridRow1';
            } else if (gameProvider.length < 16) {
                return 'gridRow2';
            } else {
                return 'gridRow3';
            }
        },
        indianCardGamesClass() {
            const indianCardGames = this.casinoGames?.menus?.find(menu => menu.slug == 'indian-card-games')?.games || [];
            if (indianCardGames.length < 8) {
                return 'gridRow1';
            } else if (indianCardGames.length < 16) {
                return 'gridRow2';
            } else {
                return 'gridRow3';
            }
        },
        popularGameClass() {
            const popularGame = this.casinoGames?.menus?.find(menu => menu.slug == 'popular-games')?.games || [];
            if (popularGame.length < 8) {
                return 'gridRow1';
            } else if (popularGame.length < 16) {
                return 'gridRow2';
            } else {
                return 'gridRow3';
            }
        },
        logInData() {
            return this.$store.getters?.logInData
        }
    },
    created() {
		this.eventManage = this.$store?.getters?.eventManage;
    },
    methods: {
        callOfferPage(){
            if((this.logInData.logInWithMobile || !this.logInData.logInWithMobile )&& this.logInData.userIds.includes(this.$auth?.user?.name ?? this.$auth?.user?.userid)) {
                setTimeout(()=>{
                    let is_offer = localStorage.getItem("is_offer");
                    if (this.$auth.status && this.$siteSettings.data.offer != null && is_offer == null && this.$siteSettings?.data?.business_type == 2) {
                        this.$helper.openModal("#offer_pop_up");
                    }
                },500)
            }
        },
        routeToCasinoAsPerProvider(providerId){
            this.$router.push({ name: 'Casino', params: { section: 'casino' }, query: { provider: providerId } });
        },
        loadGame(game) {
            if(!this.$auth.status) {
                this.$helper.showLogin();
                this.$errorToast("Login To View Games");
                return;
            }
            loadCasinoGame.loadGame(game, this.$auth.user);
        },
        scrollToLeft(index){
            const element = this.$refs['slideItem'+index]
            if(element){
                element.scrollLeft = 0;
            }
        },
        scrollLeft(index) {
            const element = this.$refs['slideItem'+index]
            if (element) {
                element.scrollLeft -= 150;
            }
        },
        scrollRight(index) {
            const element = this.$refs['slideItem'+index]
            if (element) {
                element.scrollLeft += 150;
            }
        },
        checkEventManageforSports,
        checkInEventMangeForSection,
        checkForLockedMatches,
        getInplayMatches() {
            this.$store.dispatch('setGlobalLoader',true)
            this.$apiCall('GET', 'INPLAY_MATCHES_LIST', null, 'sports', ).then(response => {
                this.loading = false;
                this.$store.dispatch('setGlobalLoader',false)
                if (response && response.status == 200) {
                    this.allData = response.data.data;
                    this.inplayMarketOdds = {};
                    var inplay_match_list = response.data.data.inplay
                    var cricket = []
                    var soccer = []
                    var tennis = []
                    let lockedMatchIds = [];
                    let lockedLeagueIds = [];
                    if(this.$auth.status && this.eventManage) {
                        lockedMatchIds = this.eventManage.find(item => item.type == 'match');
                        lockedLeagueIds = this.eventManage.find(item => item.type == 'league');

                        lockedMatchIds = lockedMatchIds && lockedMatchIds.type_id !== null ? lockedMatchIds.type_id.split(',') : [];
                        lockedLeagueIds = lockedLeagueIds && lockedLeagueIds.type_id !== null ? lockedLeagueIds.type_id.split(',') : []
                    }
                    for (var i = 0; i < inplay_match_list.length; i++) {
                        if(this.checkEventManageforSports(inplay_match_list[i].sport_id) && this.checkForLockedMatches(inplay_match_list[i].matchId, inplay_match_list[i].league_id, lockedMatchIds, lockedLeagueIds)) {
                            if (inplay_match_list[i].sport_id == 4) {
                                cricket.push(inplay_match_list[i])
                            } else if (inplay_match_list[i].sport_id == 1) {
                                soccer.push(inplay_match_list[i])
                            } else if (inplay_match_list[i].sport_id == 2) {
                                tennis.push(inplay_match_list[i])
                            } else {
                                if(!this.secondaryInplayMatches[inplay_match_list[i].sport_name]){
                                    this.secondaryInplayMatches[inplay_match_list[i].sport_name] = [];
                                };
                                this.secondaryInplayMatches[inplay_match_list[i].sport_name].push(inplay_match_list[i])
                            }
                            this.inplayMarketOdds[inplay_match_list[i].market_id] = inplay_match_list[i]?.runners ?? [];
                        }
                    }
                    this.inplayMatches['Cricket'] = cricket
                    this.inplayMatches['Soccer'] = soccer
                    this.inplayMatches['Tennis'] = tennis
                    if(Object.entries(this.inplayMarketOdds).length) {
                        socketService.emit("sub", 'inplay.markets');
                        socketService.on("inplay.markets", (bMarketOdds) => {
                            for(let incomingMarket in bMarketOdds){
                                let marketOdd = this.inplayMarketOdds[incomingMarket];
                                let newMarketOdds = bMarketOdds[incomingMarket];
                                if(!marketOdd) return;
                                if(newMarketOdds?.runners){
                                    for(let runner of newMarketOdds.runners) {
                                    let mRunner = marketOdd.find(r=> r.sid == runner.sid);
                                    if(!mRunner) continue;
                                    // back available 
                                    if(runner?.ex?.b) {
                                        mRunner.ex.b = runner?.ex?.b;
                                    }
                                    // lay available
                                    if(runner?.ex?.l) {
                                        mRunner.ex.l = runner?.ex?.l;
                                    }
                                }
                                }
                                
                            }
                        })
                    }
                }
            }).catch(error => {
                this.loading = false;
                this.$store.dispatch('setGlobalLoader',false)
                if (error) {
                }
            });
        },

        getUpcomingMatches() {
            this.loading = true;
            this.$store.dispatch('setGlobalLoader',true)
            this.$apiCall('get', 'GET_UPCOMING_SPORTS', null, 'sports', { day: 'upcoming' }).then(response => {
                this.loading = false;
                this.$store.dispatch('setGlobalLoader',false)
                if (response && response.status == 200) {
                    var upcoming_match_list = response.data.data.sort().reverse();
                    let lockedMatchIds = [];
                    let lockedLeagueIds = [];
                    this.ipcomingMarketOdds = {};

                    if(this.$auth.status && this.eventManage) {
                        lockedMatchIds = this.eventManage.find(item => item.type == 'match');
                        lockedLeagueIds = this.eventManage.find(item => item.type == 'league');

                        lockedMatchIds = lockedMatchIds && lockedMatchIds.type_id !== null ? lockedMatchIds.type_id.split(',') : [];
                        lockedLeagueIds = lockedLeagueIds && lockedLeagueIds.type_id !== null ? lockedLeagueIds.type_id.split(',') : []
                    }
                    if (this.$auth.status) {
                        for (var i = 0; i < upcoming_match_list.length; i++) {
                            if (this.favouriteSportsList?.includes(parseInt(upcoming_match_list[i].event_id))) {
                                upcoming_match_list[i]['favourite'] = true
                            } else {
                                upcoming_match_list[i]['favourite'] = false
                            }
                        }
                    }

                    var rec_cricket = []
                    var rec_soccer = []
                    var rec_tennis = []
                    for (var i = 0; i < upcoming_match_list.length; i++) {
                        if(this.checkEventManageforSports(upcoming_match_list[i].sport_id) && this.checkForLockedMatches(upcoming_match_list[i].matchId, upcoming_match_list[i].league_id, lockedMatchIds, lockedLeagueIds)) {
                            if (upcoming_match_list[i].sport_id == 4) {
                                rec_cricket.push(upcoming_match_list[i])
                            } else if (upcoming_match_list[i].sport_id == 1) {
                                rec_soccer.push(upcoming_match_list[i])
                            } else if (upcoming_match_list[i].sport_id == 2) {
                                rec_tennis.push(upcoming_match_list[i])
                            } else {
                                if(!this.secondaryUpcomingMatches[upcoming_match_list[i].sport_name]){
                                    this.secondaryUpcomingMatches[upcoming_match_list[i].sport_name] = [];
                                };
                                this.secondaryUpcomingMatches[upcoming_match_list[i].sport_name].push(upcoming_match_list[i])
                            }
                            this.upcomingMarketOdds[upcoming_match_list[i].market_id] = upcoming_match_list[i]?.runners ?? [];
                        }
                    }
                    this.upcomingMatches['Cricket'] = rec_cricket
                    this.upcomingMatches['Soccer'] = rec_soccer
                    this.upcomingMatches['Tennis'] = rec_tennis
                    if(Object.entries(this.upcomingMarketOdds).length) {
                        socketService.emit("sub", 'inplay.markets');
                        socketService.on("inplay.markets", (bMarketOdds) => {
                            for(let incomingMarket in bMarketOdds){
                                let marketOdd = this.upcomingMarketOdds[incomingMarket];
                                let newMarketOdds = bMarketOdds[incomingMarket];
                                if(!marketOdd) return;
                                if(newMarketOdds?.runners){
                                    for(let runner of newMarketOdds.runners) {
                                    let mRunner = marketOdd.find(r=> r.sid == runner.sid);
                                    if(!mRunner) continue;
                                    // back available 
                                    if(runner?.ex?.b) {
                                        mRunner.ex.b = runner?.ex?.b;
                                    }
                                    // lay available
                                    if(runner?.ex?.l) {
                                        mRunner.ex.l = runner?.ex?.l;
                                    }
                                }
                                }
                                
                            }
                        })
                    }
                }
            }).catch(error => {
                this.loading = false;
                this.$store.dispatch('setGlobalLoader',false)
                if (error) {
                    console.log("Error : ", error);
                }
            });
        },
        
        getCasinoGamesServiceCall() {
            const games = this.gamesData
            this.sectionsList = games?.sections;
            if (this.$auth.status) {
                checkInEventMangeForSection(games)
                this.$store.dispatch('setGamesData', games);
            }
            this.setSectionList();
        },
        setSectionList() {
            try {
                for (let i = 0; i < this.sectionsList?.length; i++) {
                    let gamesList = [];
                    if (this.sectionsList[i].menus) {
                        for (let j = 0; j < this.sectionsList[i].menus.length; j++) {
                            gamesList = gamesList.concat(this.sectionsList[i]?.menus[j]?.games);
                        }
                    } else {
                        gamesList = this.sectionsList[i].games;
                    }

                    let gameListNew = [];
                    if (this.$auth.status) {

                        for (var k = 0; k < gamesList.length; k++) {
                            if (this.favouriteEvents?.includes(gamesList[k].id)) {
                                gamesList[k]['favourite'] = true
                            } else {
                                gamesList[k]['favourite'] = false
                            }
                            gameListNew.push(gamesList[k]);
                        }
                    } else {
                        gameListNew = gamesList;
                    }
                    const naturalCollator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
                    gameListNew.sort((a, b) => naturalCollator.compare(a.porder, b.porder));

                    switch (this.sectionsList[i].slug) {
                        case 'royal-live-games':
                            this.sectionWiseGamesList[1].gamesList = gameListNew;
                            break;
                        case 'top-games':
                            this.sectionWiseGamesList[0].gamesList = gameListNew;
                            break;
                    }
                    
                }

            } catch (error) {
                console.log(error);
            }
        },
        
        callOpenBet() {
            if (this.$auth.status) {
                this.$router.push({ name: 'bets' })
            }
            else {
                this.$refs.open_login_modal.click();
            }
        },
        getFavouriteList() {
            this.loading = true;
                this.$store.dispatch('setGlobalLoader',true)
            let data = {
                "game_type": 0
            }
			this.$apiCall('post', 'GET_FAVOURITE_LIST', data).then(response => {
                this.loading = false;
                this.$store.dispatch('setGlobalLoader',false)
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0) {
                            this.$errorToast(response.data.debug[0]);
                        }
                        else {
                            var allData = response.data.data;
                            for (var i = 0; i < allData.length; i++) {
                                this.favouriteList.push(allData[i].match_id)
                            }
                            localStorage.setItem('fav_events', this.favouriteList)

                            for (var i = 0; i < this.allData?.inplay?.length; i++) {
                                if (this.favouriteList.includes(this.allData.inplay[i].matchId)) {
                                    this.allData.inplay[i]['favourite'] = true
                                } else {
                                    this.allData.inplay[i]['favourite'] = false
                                }
                            }

                            for (var j = 0; j < this.allData?.recommended?.length; j++) {
                                if (this.favouriteList.includes(this.allData.recommended[j].matchId)) {
                                    this.allData.recommended[i]['favourite'] = true
                                } else {
                                    this.allData.recommended[i]['favourite'] = false
                                }
                            }
                        }
                    }
                }
            }).catch(error => {
                this.loading = false;
                this.$store.dispatch('setGlobalLoader',false)
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
        
    },
    beforeUnmount() {
        socketService.off('inplay.markets');
        socketService.emit("leave", ['inplay.markets']);
    }
}

</script>
<style>
.available-credit-sec {
    margin-top: 0px;
    margin-bottom: 10px;
}
</style>